import { render, staticRenderFns } from "./RefereesTable.vue?vue&type=template&id=6feb68f2&"
import script from "./RefereesTable.vue?vue&type=script&lang=js&"
export * from "./RefereesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports